import SynchronizedRefresh from 'AnalyticsLibrary/technologies/tableau/extensions/synchronized-refresh/SynchronizedRefresh';
import * as React from 'react';
import { ReactNode } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom';
import PageNotFound from 'Common/components/PageNotFound';
import { navOptions as allNavOptions, SubNavItem } from '../content';
import Home from '../content/general/Home';
import SignUp from '../content/general/SignUp';
import * as Paths from './paths';
import { AppBase } from 'Common/common-ui';

export const childRoutes: string[] = [
  Paths.AccessTool,
  Paths.SqlTranslation,
  Paths.AnalyticsLibrary,
  Paths.Documentation,
  Paths.ProvisionTool,
];

export default function AppRouter(): ReactNode {
  const navOptions = allNavOptions;
  const optionItems = Object.keys(navOptions);

  function generateRoutePath(route: string): string {
    return childRoutes.includes(route) ? `${route}/*` : route;
  }

  function generateRouters() {
    return createBrowserRouter(
      createRoutesFromElements(
        <Route
          path={Paths.Home}
          element={
            <AppBase navOptions={navOptions}>
              <Outlet />
            </AppBase>
          }
        >
          <Route index element={<Home />} />
          {optionItems.map((option: string) =>
            navOptions[option].children.map((subRoute: SubNavItem) => {
              if (subRoute.children) {
                return (
                  <Route
                    key={subRoute.title}
                    path={generateRoutePath(subRoute.to)}
                    element={subRoute.component}
                    loader={subRoute.loader}
                    action={subRoute.action}
                    shouldRevalidate={subRoute.shouldRevalidate}
                  >
                    {subRoute.children}
                  </Route>
                );
              } else {
                return (
                  <Route
                    key={subRoute.title}
                    path={generateRoutePath(subRoute.to)}
                    element={subRoute.component}
                    loader={subRoute.loader}
                    action={subRoute.action}
                    shouldRevalidate={subRoute.shouldRevalidate}
                  />
                );
              }
            })
          )}
          <Route path={Paths.SignUp} element={<SignUp />} />
          <Route path={Paths.AllPaths} element={<PageNotFound />} />
          <Route path={Paths.Health} element={<>HEALTHY</>} />
          <Route
            path={`${Paths.TableauExtensions}/*`}
            element={<SynchronizedRefresh />}
          />
        </Route>
      )
    );
  }

  return <RouterProvider router={generateRouters()} />;
}
